var dropDownHandler = () => {
    const dropdowns = document.querySelectorAll('.dropdown');
    if (dropdowns) {
        dropdowns.forEach(dropdown => {
            dropdown.addEventListener('click', function (event) {
                event.stopPropagation();
                dropdown.classList.toggle('is-active');
            });
        });

        // also close dropdown when clicking outside
        document.addEventListener('click', function (event) {
            dropdowns.forEach(dropdown => {
                dropdown.classList.remove('is-active');
            });
        });
    }
}